import { createContext, useContext } from 'react'

import type { PendingDashboardWrite } from 'features/dashboards-v2-1/types/dashboard-page-write'

export interface DashboardPageWriteType {
  /**
   * What Ask Yogi changed on the 2.1 dashboard in the turn that just came
   * back, waiting for the dashboard to apply it. Null the rest of the time.
   */
  dashboardWrite: PendingDashboardWrite | null
  /** Emptied by the dashboard once it has applied (or skipped) the write. */
  clearDashboardWrite: () => void
}

/**
 * The write-back half of the dashboard seam, on its own context for the
 * reasons `ChartPageWriteContext` gives: it changes exactly when Ask Yogi
 * writes the dashboard, which is a render the page needs, while the
 * registration context must never change and the wide Ask Yogi value changes
 * on every widget toggle.
 */
export const DashboardPageWriteContext =
  createContext<DashboardPageWriteType | null>(null)

/** Null outside the provider (the public share page), never throws. */
export const useDashboardPageWrite = (): DashboardPageWriteType | null =>
  useContext(DashboardPageWriteContext)
